import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderConstants } from '../../app-core/constants/common-constants';
import { RequestStatus } from '../../app-core/enums/common-enum';
import { CommonService } from '../../app-core/services/common.service';
import { LoaderService } from '../../app-core/services/loader.service';
import { UpdateDialogComponent } from '../update-dialog/update-dialog.component';

@Component({
	selector: 'app-order-details',
	templateUrl: './order-details.component.html',
	styleUrl: './order-details.component.scss',
})
export class OrderDetailsComponent implements OnInit {
	orderConstants: typeof OrderConstants = OrderConstants;
	errorMessage = '';
	wismoDetails: any;
	deliveryItem: any;
	serviceItems: any[] = [];

	order = {
		orderNumber: '',
		upi: '',
		postcode: '',
		productDescription: '',
		requestedBy: '1',
	};

	contact = {
		name: 'Miss Laura Potter',
		email: 'Laura.potter@email.co.uk',
		address: '81 Kitt Green Road, Wigan',
		info: '+44 71234526789',
		phone: '+44 71234526721',
		home: '+44 71234526721',
		work: '+44 71234526721',
	};

	constructor(
		private dialog: MatDialog,
		private router: Router,
		private commonService: CommonService,
		private loaderService: LoaderService,
		private route: ActivatedRoute
	) {}

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			this.order.upi = params['upi'];
			this.order.postcode = params['postcode'];
		});
		this.loaderService.show();
		const payload = {
			orderNumber: this.order.orderNumber,
			upi: this.order.upi,
			postcode: this.order.postcode,
			requestedBy: this.order.requestedBy,
		};
		this.commonService.getWismoDetails(payload).subscribe({
			next: (res) => {
				this.wismoDetails = res?.arrowxl_wismo_response?.wismo_detail;
				const items = this.wismoDetails?.order_line_info?.order_line_info_item;
				this.deliveryItem = items.find((item: any) => item.line_type === 'Delivery' || item.line_type === 'Collection');

				this.errorMessage = this.wismoDetails?.request_error_description;
				if (this.wismoDetails.request_status === RequestStatus.FAILURE) {
					// this.router.navigate(['']);
				}
				this.loaderService.hide();
			},
			error: (err) => {
				this.errorMessage = err;
				// this.router.navigate(['']);
				this.loaderService.hide();
			},
		});
	}

	openUpdateDialog(): void {
		const dialogRef = this.dialog.open(UpdateDialogComponent, {
			width: '400px',
			disableClose: true,
			data: { message: this.orderConstants.dialogMessage },
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === 'yes') {
				this.router.navigate(['/update-order-details'], {
					queryParams: { upi: this.order.upi, postcode: this.order.postcode },
				});
			} else {
				console.log('User cancelled');
			}
		});
	}

	onConfirmDetails(): void {
		this.router.navigate(['update-order-details'], {
			queryParams: { url: 'confirm-details', upi: this.order.upi, postcode: this.order.postcode },
		});
	}
}
